"use client";

import { useTranslations } from "next-intl";
import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Popover,
} from "@/components/controls/base-controls";
import { ArrowRightAltIcon, CompareArrowsIcon } from "@/components/controls/icons";
import type { FlightValue } from "@/core/types/flight.type";
import { Flight } from "@/core/types/flight.type";

type FlightPopoverProps = {
    allowedValues: readonly FlightValue[];
    anchorEl: HTMLElement | null;
    open: boolean;
    selectedValue: FlightValue;
    onClose: (value: FlightValue) => void;
};

const FlightTypePopover = (props: FlightPopoverProps) => {
    const { allowedValues, anchorEl, open, selectedValue, onClose } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value: FlightValue) => {
        onClose(value);
    };

    const t = useTranslations();

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{ paper: { sx: { width: anchorEl?.clientWidth, mt: "8px" } } }}
        >
            <List sx={{ p: 0 }}>
                {allowedValues.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton onClick={() => handleListItemClick(item)}
                            sx={{ px: ".4em", backgroundColor: item === selectedValue ? "var(--mui-palette-selected-listitem-bg-color)" : undefined }}>
                            <ListItemAvatar sx={{ minWidth: "unset", mr: 1 }}>
                                {item === Flight.ROUNDTRIP ? <CompareArrowsIcon /> : <ArrowRightAltIcon />}
                            </ListItemAvatar>
                            <ListItemText primary={t(`flightReq.${item}`)} sx={{ mt: "-2px", flexGrow: 1 }} slotProps={{ primary: { variant: "body2" } }} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Popover>
    );
};

export default FlightTypePopover;
